import React, { useContext } from 'react'
import Button from '@material-ui/core/Button'
import Divider from '@material-ui/core/Divider'
import AutoSizer from "react-virtualized-auto-sizer";
import { VariableSizeList as List } from "react-window";
import { CreateCartoMapContext } from '../../../../../contexts/carto-maps-context'
import { ZONES_LIST_MAX_HEIGHT } from '../../constants'
import ZoneCard from '../ZoneCard'
import EmptyMessage from '../EmptyMessage'
import './style.css';
import { Typography } from '@material-ui/core';

const ToProjectCard = () => {
    const { fromProject, fromDisplayedZones, setFromDisplayedZones, zonesSelected } = useContext(CreateCartoMapContext)

    function handleOnClick (id) {
        // remove toProjects
        const newZones = zonesSelected.zones.filter(zone => zone._id !== id)
        zonesSelected.setZones(newZones)

        // push fromProject
        const zoneToCopy = fromProject.zones.find(zone => zone._id === id)
        setFromDisplayedZones([ ...fromDisplayedZones, zoneToCopy ])
    }

    function removeAllZones() {
        setFromDisplayedZones(fromProject.zones)
        zonesSelected.setZones([])
    }

    function renderRows () {
        if (zonesSelected.zones.length === 0) {
            return <EmptyMessage>You need to select at least one Zone you want to visualize in Carto</EmptyMessage>
        }

        return  (
            <AutoSizer> 
                {({ height, width }) => (
                    <List
                        height={height < ZONES_LIST_MAX_HEIGHT ? height : ZONES_LIST_MAX_HEIGHT}
                        itemCount={ zonesSelected.zones.length }
                        itemData={{ zones: zonesSelected.zones, onClick: handleOnClick, mode: 'remove' }}
                        itemSize={() => 60}
                        width={width}
                    >
                    { ZoneCard }
                    </List>
                )}
            </AutoSizer>
        )
    }

    return (
        <div className="add-to-map-card-container">
            <div className="flex-container card-header">
                <h4>Zones to Visualise</h4>
            </div>
            <Divider component="div"/>
            <div className="zones-section-label-wrapper">
                <h5>Zones to Visualise</h5>
                <Button color="primary" onClick={removeAllZones}>
                    <Typography variant="button">
                        REMOVE ALL  
                    </Typography>
                </Button>
            </div>
            { renderRows() }
        </div>
    )
}

export default ToProjectCard